<template>
    <div class="login">
        <div class="login-panel">
            <div class="login-form">
                <p class="title">{{title}}</p>
                <el-input type="text" placeholder="用户名" v-model="userForm.username">
                    <div slot="prefix" class="input-prefix">
                        <i class="iconfont icon-account-outline"></i>
                        <div class="seperator"></div>
                    </div>
                </el-input>
                <el-input :type="showPassword.loginPassword ? 'text': 'password'" placeholder="密码" v-model="userForm.password">
                    <div slot="prefix" class="input-prefix">
                        <i class="iconfont icon-password"></i>
                        <div class="seperator"></div>
                    </div>
                    <el-button slot="suffix" type="text" @click="showPassword.loginPassword = !showPassword.loginPassword">
                        <i class="iconfont" :class="[showPassword.loginPassword ? 'icon-password-show' : 'icon-password-hidden']"></i>
                    </el-button>
                </el-input>
                <el-button type="primary" @click="login">
                    登录
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { CommonApi } from '../http/common';
import { webSocketMixins } from "../utils/webSocketMixins";

export default {
    name: "login",
    mixins: [webSocketMixins],
    data(){
        return {
            userForm: {
                username: "",
                password: ""
            },
            showPassword: {
                loginPassword: false
            },
            title: "欢迎使用"
        }
    },
    created(){
    },
    mounted(){
        window.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy(){
        window.removeEventListener('keydown', this.handleKeyDown);
    },
    methods: {
        login(){
            if(!this.userForm.username){
                this.$notify.error({title: "请输入用户名"});
                return false;
            }
            if(!this.userForm.password){
                this.$notify.error({title: "请输入密码"});
                return false;
            }
            CommonApi.login(this.userForm).then(res => {
                if(res.data.status === 200){
                    localStorage.setItem('authToken', res.data.content.token);
                    localStorage.setItem('userInfo', JSON.stringify(res.data.content));
                    this.$store.commit("updateUserInfo", res.data.content);
                    // 更新菜单
                    CommonApi.getMenuList().then(res => {
                        this.$store.commit('updateMenuList', res);
                        if(res[0].children.length > 0)
                            this.$router.replace(res[0].children[0].index);
                        else
                            this.$router.replace(res[0].index);
                    });

                    this.$store.commit('updateBreadcrumb', [{"name":"基础数据","path":"/Basic"},{"name":"线路","path":"/Basic/RailwayLine"}]);
                    
                } else if(res.data.status != 403){
                    this.$notify.error({title: res.data.message});
                }
            });
        },

        handleKeyDown(event){
            if(event.keyCode === 13){
                this.login();
            }
        }
    },
};
</script>

<style lang="less">
div.login{
    justify-content: center;
    display: flex;
    div.login-panel{
        text-align: center;
        width: 65.625vw;
        div.login-form{
            p.title{
                font-size: 2.77778vh;
                margin: 0 0 1.6vh 0;
                font-weight: bold;
                color: #5473E8;
                width: 20vw;
            }
            transform: translateY(-60%);
            display: inline-block;
            text-align: left;
            margin-top: 50vh;
            width: 18vw;
            .el-input{
                margin-bottom: 1.6vh;
            }
            .el-button{
                width: 100%;
            }
        }
    }
    div.input-prefix{
        display: flex;
        div.seperator{
            margin: .8rem 0 .8rem .8rem;
            background: #f0f0f0;
            height: 2.4rem;
            width: .1rem;
        }
    }
    .el-input--prefix .el-input__inner{
        padding: 0 4.8rem;
    }
    .el-input__prefix{
        left: 1rem;
        i{
            line-height: 4rem;
            font-size: 2rem;
        }
    }
    .el-input__suffix{
        right: 1rem;
        i{
            line-height: 1.4rem;
            font-size: 1.8rem;
            color: #9d9d9d;
        }
    }
    div.extra-function{
        justify-content: space-between;
        display: flex;
        .el-button{
            width: fit-content!important;
            margin-top: 1.6rem;
            padding: 0;
        }
    }
}
</style>
